import backendVerifiedUser from "../../api/backendVerifiedUser";
import {
  CLOSE_LOADER,
  SET_ERROR,
  SET_LOADER,
  SET_SUCCESS,
} from "../Types/AuthTypes";
import { SET_COUPONS, SET_SPECIFIC_COUPON } from "../Types/CouponTypes";

export const getCoupons = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-coupons");
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_COUPONS, payLoad: response.data.success.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_ERROR, payLoad: err.response?.data?.error?.msg });
    }
  };
};

export const addCoupon = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/add-coupon", data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_ERROR, payLoad: err.response?.data?.error?.msg });
      return false;
    }
  };
};

export const getSpecificCoupon = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(`/get-specific-coupon/${id}`);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SPECIFIC_COUPON, payLoad: response.data.success.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_ERROR, payLoad: err.response?.data?.error?.msg });
    }
  };
};

export const updateCoupon = (data, id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(`/update-coupon/${id}`, data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_ERROR, payLoad: err.response?.data?.error?.msg });
      return false;
    }
  };
};

export const deleteMultipleCoupons = (ids) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/delete-multiple-coupons", { ids });
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_ERROR, payLoad: err.response?.data?.error?.msg });
      return false;
    }
  };
};
